import { useEffect, useState, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../../../../utils/axiosInstance";
import ProjectDetailsCard from "./ProjectDetailsCard";
import ManagerStatusCard from "./ManagerStatusCard";
import MessageCard from "./MessageCard";
import { toast } from "../../../../../components/Toast/toast";

const DetailsPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchProject = useCallback(async () => {
    try {
      const response = await api.get(`/projects/${id}`, {
        withCredentials: true,
      });
      setProject(response.data.data);
    } catch (err) {
      console.error(err);
      setError("Failed to fetch project details");
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchProject();
  }, [id, fetchProject]);

  const handleEdit = () => {
    navigate(`/project/edit/${id}`);
  };

  const handleDelete = async () => {
    try {
      await api.delete(`/projects/${id}`, { withCredentials: true });
      toast.success("Project deleted");
      navigate("/projects");
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || "Failed to delete project");
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center py-10">
        <div className="animate-spin rounded-full h-8 w-8 border border-gray-300 border-t-brand-600" />
      </div>
    );
  }

  if (error) return <p className="text-danger-600 text-sm">{error}</p>;
  if (!project) return <p className="text-sm text-gray-500">Project not found.</p>;

  return (
    <div className="space-y-5">
      <div className="flex flex-col lg:flex-row gap-5">
        <div className="flex-1">
          <ProjectDetailsCard
            project={project}
            onEdit={handleEdit}
            onDelete={handleDelete}
          />
        </div>

        <div className="lg:w-[500px]">
          <ManagerStatusCard project={project} />
        </div>
      </div>
      <MessageCard />
    </div>
  );
};

export default DetailsPage;